import LegalPage from '../components/LegalPage'

export default function RodoPage() {
  return (
    <LegalPage title="Polityka prywatności (RODO)">
      <p>
        Zgodnie z art. 13 ust. 1 i 2 ogólnego rozporządzenia o ochronie danych osobowych Parlamentu
        Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób
        fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu
        takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych,
        dalej: „RODO”) Światy Równoległe sp. z o.o. z siedzibą w Krakowie informują, iż:
      </p>

      <ol>
        <li>
          Administratorem Twoich danych osobowych są Światy Równoległe sp. z o.o. z siedzibą w
          Krakowie, ul. Walerego Sławka 20/12, 30-633.
        </li>
        <li>
          W sprawach związanych z ochroną danych osobowych można kontaktować się z naszym inspektorem
          ochrony danych pod adresem email michal@abonamentyliterackie.pl oraz na adres siedziby
          administratora.
        </li>
        <li>
          Będziemy przetwarzać Twoje dane osobowe w celu poprawnego wykonania usługi subskrypcji
          książkowych i ich wysyłki, jak również do indywidualnego dostosowania subskrypcji do Twoich
          potrzeb (w przypadku usługi abonamentów personalizowanych), w szczególności w celach
          archiwizacji informacji dotyczących Twoich preferencji literackich, dotychczas otrzymanych
          przesyłek oraz byłych subskrypcji, w zakresie zgodnym z:
          <ul>
            <li>
              art. 6 ust. 1 lit. a RODO, kiedy osoba, której dane dotyczą, wyraziła zgodę na
              przetwarzanie swoich danych osobowych w jednym lub większej liczbie określonych celów;
            </li>
            <li>
              art. 6 ust. 1 lit. b RODO, kiedy przetwarzanie jest niezbędne do wykonania umowy,
              której stroną jest osoba, której dane dotyczą, lub do podjęcia działań na żądanie osoby,
              której dane dotyczą, przed zawarciem umowy.
            </li>
          </ul>
        </li>
        <li>
          Odbiorcami Twoich danych osobowych będą podmioty, z którymi Światy Równoległe sp. z o.o.
          zawarły umowy na świadczenie usług informatycznych i pocztowych.
        </li>
        <li>
          Twoje dane osobowe będziemy przechowywać przez okres trwania usługi oraz do roku czasu po
          zakończeniu trwania usługi, w celu zachowania ciągłości danych w przypadku powrotu do usługi.
        </li>
        <li>
          W granicach wyznaczonych przez RODO przysługuje Ci prawo do:
          <ul>
            <li>
              żądania od administratora dostępu do danych osobowych oraz uzyskania ich kopii,
            </li>
            <li>sprostowania danych osobowych,</li>
            <li>usunięcia swoich danych osobowych,</li>
            <li>ograniczenia przetwarzania swoich danych osobowych,</li>
            <li>
              cofnięcia w dowolnym momencie zgody na przetwarzanie danych osobowych przez kontakt
              mailowy z administratorem praw osobowych – jeżeli przetwarzanie Twoich danych odbywa
              się na jej podstawie,
            </li>
            <li>przenoszenia swoich danych osobowych.</li>
          </ul>
          W granicach wyznaczonych przez RODO przysługuje Ci także prawo wniesienia sprzeciwu wobec
          przetwarzania Twoich danych osobowych.
        </li>
      </ol>

      <p>
        Jeśli uznasz, że przetwarzanie Twoich danych osobowych narusza przepisy RODO, przysługuje Ci
        prawo wniesienia skargi do organu nadzorczego, tj. Prezesa Urzędu Ochrony Danych Osobowych.
      </p>
      <p>
        Podanie danych osobowych jest dobrowolne, ale niepodanie lub brak zgody na przetwarzanie
        danych skutkować będzie brakiem możliwości przystąpienia do usług wykonywanych przez Światy
        Równoległe sp. z o.o. lub odstąpieniem od umowy przez Światy Równoległe sp. z o.o.
      </p>
      <p>
        Twoje dane osobowe nie będą przekazywane poza terytorium Europejskiego Obszaru Gospodarczego
        ani do organizacji międzynarodowej.
      </p>
      <h2 className="text-xl font-bold mt-8 mb-4">Pliki cookie i narzędzia marketingowe</h2>
      <p>
        Na stronie używamy Meta Pixel (Facebook Pixel) do pomiaru skuteczności działań marketingowych
        i remarketingu. Pixel zapisuje pliki cookie i może przekazywać Meta informacje o odwiedzinach
        oraz zdarzeniach (np. dodanie subskrypcji do koszyka, przejście do płatności). Korzystamy z
        niego wyłącznie po uzyskaniu Twojej zgody, którą możesz w każdej chwili wycofać, zmieniając
        wybór w banerze cookie lub czyszcząc ustawienia przeglądarki.
      </p>
    </LegalPage>
  )
}
